import { assetUrl } from "@/lib/api";

function Media({ it }) {
  return it.type === "video" ? (
    <video autoPlay muted loop playsInline preload="auto">
      {it.webm && <source src={assetUrl(it.webm)} type="video/webm" />}
      <source src={assetUrl(it.mp4 || it.url)} type="video/mp4" />
    </video>
  ) : (
    <img src={assetUrl(it.url)} alt="" loading="lazy" />
  );
}

// Fixed 2-column x 3-row editorial mosaic (exactly 6 cells).
export function Mosaic({ items }) {
  const list = Array.isArray(items) ? items.slice(0, 6) : [];
  const cells = list.length
    ? [...list, ...Array.from({ length: Math.max(0, 6 - list.length) }, (_, i) => ({ placeholder: true, mid: `ph-${i}` }))]
    : Array.from({ length: 6 }, (_, i) => ({ placeholder: true, mid: `ph-${i}` }));

  return (
    <div className="mosaic" data-testid="image-mosaic">
      {cells.map((it, i) =>
        it.placeholder ? (
          <div key={it.mid} className="mosaic-item hero-full-placeholder" data-testid="mosaic-placeholder" />
        ) : (
          <figure key={it.mid || i} className="mosaic-item" data-testid={`mosaic-item-${i}`}>
            <Media it={it} />
          </figure>
        )
      )}
    </div>
  );
}
